"use strict";

angular.module("vendor")
.controller("CustomerToApproveController", function(
    $scope, CustomerToApproveService, PartnershipStatusFilterService, PartnershipTagService
) {
    $scope.service = CustomerToApproveService;
    $scope.statusFilterService = PartnershipStatusFilterService;
    $scope.tagFilterService = PartnershipTagService;

    this.refreshOnBulkAction = function() {
        $scope.$broadcast("doResetListing");
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-to-approve.controller.js
// module id = 992
// module chunks = 0